import React, { useState, useRef } from 'react';

import Head from 'next/head';
import Axios from 'axios';
import getMetaTagData from '../../src/common/services/getMetaTagData';

import JumbotronEvent from '../../src/component/pc/carousel/JumbotronEvent';
import EventMainList from '../../src/component/pc/event/EventMainList';

function Event({ eventData, metaTagData, JWTTockenCheck }) {
  const jWTCheck = JWTTockenCheck; // 쓰일여지가있어서 살려둠
  const { top, bottom } = eventData;

  const [relateContentIndex, setRelateContentIndex] = useState(0);
  const relateContentIndexStatus = { timeoutId: 0, changedTime: Date.now() };
  const childRef = useRef(null);

  const onChangeMainTopFormationIndex = (index) => {
    const slaveSlideDelayTime = 200;
    // 0.2초 이내에 변경된 경우 슬라이딩 취소
    if (
      Date.now() - relateContentIndexStatus.changedTime <
      slaveSlideDelayTime
    ) {
      if (relateContentIndexStatus.timeoutId > 0) {
        clearTimeout(relateContentIndexStatus.timeoutId);
        relateContentIndexStatus.timeoutId = 0;
        relateContentIndexStatus.changedTime = Date.now();
      }
    }

    const timeoutId = setTimeout(() => {
      relateContentIndexStatus.changedTime = Date.now();
      setRelateContentIndex(index);
    }, slaveSlideDelayTime);
    relateContentIndexStatus.timeoutId = timeoutId;
  };

  const mainOnMouseOver = (e) => {
    childRef.current.mainOnMouseOver(e);
  };

  const mainOnMouseOut = (e) => {
    childRef.current.mainOnMouseOut(e);
  };

  return (
    <>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents">
        {/* 페이지 명 클래스 */}
        <div className="event_listcontents_wrap">
          <h2 className="hide">event</h2>
          {/* 이벤트 섹션 top 영역 시작 : 상단 스와이프 모듈 */}
          {/* <div className='event_topswipe_w'> */}
          {/* api 데이터 나올시 아래꺼로 할것 */}
          {Array.isArray(top) && top.length > 0 && (
            <JumbotronEvent
              data={top}
              props={{ type: 'eventtopbox' }}
              onChangeCurrentIndex={onChangeMainTopFormationIndex}
              ref={childRef}
            />
          )}

          {Array.isArray(bottom) && bottom.length > 0 && (
            <EventMainList data={bottom} />
          )}
        </div>
      </div>
    </>
  );
}

// api 호출하는 부분
export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;
  let metaTagData;
  let eventData;
  let JWTTockenCheck;

  try {
    if (LOGIN_JWT != null) {
      JWTTockenCheck = true;
    } else {
      JWTTockenCheck = false;
    }
    metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함) import 된 부분에서 호출됨
    eventData = await eventDataList();
  } catch (error) {
    console.error(error);
  }

  return { props: { eventData, metaTagData, JWTTockenCheck } };
}

const eventDataList = async () => {
  try {
    const liveEventList = await Axios.get(
      process.env.NEXT_PUBLIC_API_EVENT_LIST,
      { timeout: 3000 }
    );
    const eventData = liveEventList.data;

    return eventData;
  } catch (e) {
    console.error(e);
  }
};

export default Event;
